export function throttle(fn, delay = 100) {
    // 设置变量默认为true
    let flag = true;
    // 为了保证this指向，返回一个箭头函数
    return (...args) => {
        // 判断如果已经在执行就直接return
        if (!flag) return;
        // 否则就是没有执行，将状态赋值为false
        flag = false;
        // 设置定时器，设置时间
        setTimeout(() => {
            // 调用apply方法确保this指向问题
            fn.apply(this, args);
            // 最后将状态重新更改为true，以便程序下次执行
            flag = true;
        }, delay)
    };
}
